// An autoresize directive that works with ion-textarea in Ionic 2
// Usage example: <ion-textarea autoresize [(ngModel)]="body"></ion-textarea>
// Based on https://www.npmjs.com/package/angular2-autosize

import { Directive, HostListener, ElementRef } from "@angular/core";

@Directive({
	selector: "ion-textarea[autoresize]" // Attribute selector
})
export class Autoresize {

	@HostListener("input", ["$event.target"])
	
  onInput(textArea: HTMLTextAreaElement): void {
		this.adjust();
	}
	
  constructor(public element: ElementRef) {
	}
	
  ngOnInit(): void {
		this.adjust();
	}

	adjust(): void {
		let ta = this.element.nativeElement.querySelector("textarea");
    if (!ta) return;

		ta.style.overflow = "hidden";
		ta.style.height = "auto";
    setTimeout(() => {
      ta.style.height = ta.scrollHeight + "px";
    }, 100);
		ta.style.height = ta.scrollHeight + "px";
	}

}


// WEBPACK FOOTER //
// ./src/components/ion-textarea-autoresize.ts